import { createAction } from '@reduxjs/toolkit';

import type { GiftCertificate } from './gift_cert.types';

const save = {
  pending: createAction<string | null>('giftCert/save/pending'),
  fulfilled: createAction<GiftCertificate | null>('giftCert/save/fulfilled'),
  invalid: createAction<string>('giftCert/save/invalid'),
  rejected: createAction('giftCert/save/rejected'),
};

const getDetails = {
  pending: createAction('giftCert/getDetails/pending'),
  fulfilled: createAction<GiftCertificate>('giftCert/getDetails/fulfilled'),
  rejected: createAction('giftCert/getDetails/rejected'),
};

export default { save, getDetails };
